module.exports = __webpack_public_path__ + "img/SKMJ_limit5.7f3f8a1c.jpg";